import { graphql } from "@/graphql/codegen"

export const BatchAddProductsToEquivalencyGroupDocument = graphql(`
  mutation BatchAddProductsToEquivalencyGroup($input: BatchAddProductsToEquivalencyGroupInput!) {
    equivalencyGroup {
      batchAddProductsToEquivalencyGroup(input: $input) {
        ... on BatchAddProductsToEquivalencyGroupSuccess {
          success
        }
        ... on EquivalencyGroupFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
